import React from "react";

const Text = props => {
	return <div className="col-md-8 pr-md-5 project-text">{props.children}</div>;
};
export default Text;
